// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__YQZqP","header":"ClearentDisclaimer_header__21adJ","inner":"ClearentDisclaimer_inner__11mJn"};